<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.quote.edit_item' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container">

    <div>
        <div class="jobcard-label">{{'bikeshop.modal.component.sku' | translate}}</div>
        <hub-input [(ngModel)]="lineItem.SKU" [isDisabled]="true"></hub-input>
    </div>

    <div class="margin-top-16">
        <div class="jobcard-label">{{'bikeshop.modal.update_job_card.quote.name' | translate}}</div>
        <hub-input [(ngModel)]="lineItem.Name" [isDisabled]="true"></hub-input>
    </div>

    <div class="margin-top-16">
        <div class="jobcard-label">{{'bikeshop.inventory_audit.quantity' | translate}}</div>
        <div class="quantity-container">
            <div>
                <hub-input [autofocus]="true" [(ngModel)]="quantity" [required]="true" [type]="'number'" [isDisabled]="!canEditLineItemQuatity(lineItem)"></hub-input>
            </div>
            <hub-button [style]="'outline'" [size]="'lg'" [icon]="'minus'" [disabled]="quantity < 1 || !canEditLineItemQuatity(lineItem)"
                (buttonClick)="quantity = quantity - 1"></hub-button>
            <hub-button [style]="'outline'" [size]="'lg'" [icon]="'plus-alt'" [disabled]="!canEditLineItemQuatity(lineItem)"
                (buttonClick)="quantity = quantity + 1"></hub-button>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="allowDiscount && discountType !== 'NONE'">
        <div class="col-12">
          <div class="jobcard-label">{{ 'bikeshop.print.total' | translate }} {{'bikeshop.modal.update_job_card.quote.discount' | translate}} <span *ngIf="lineItem.CouponDiscountApplied">({{'bikeshop.rentals.booking.coupon' | translate}})</span></div>
            <div class="quantity-container">                
                <div *ngIf="discountType === 'AMOUNT'">
                    <hub-input [(ngModel)]="discount" [isDisabled]="lineItem.CouponDiscountApplied" [required]="false" [type]="'number'"></hub-input>
                </div>
                <div *ngIf="discountType === 'LIGHTSPEED-R'">
                    <hub-dropdown [options]="discounts" [disabled]="lineItem.CouponDiscountApplied || !discounts || discounts.length === 0" (selectionChange)="discountSelected($event)"
                          [(ngModel)]="discountID"></hub-dropdown>
                </div>
                <hub-button [style]="'outline'" [size]="'lg'" [disabled]="lineItem.CouponDiscountApplied || discount === 0" [icon]="'trash'" (buttonClick)="clearDiscount()"></hub-button>
            </div>            
        </div>
    </div>
    <div class="row margin-top-16">
        <div class="col-6">
          <div class="jobcard-label">{{'bikeshop.modal.update_job_card.quote.unit_price' | translate}}</div>
            <hub-input [(ngModel)]="price" [required]="true" [type]="'number'"></hub-input>
        </div>
        <div class="col-6">
            <div class="jobcard-label">{{'bikeshop.workshop.jobcard.quote.total_price' | translate}}</div>
            <hub-input [ngModel]="(price*quantity).toFixed(2)" [isDisabled]="true" [type]="'number'"></hub-input>
        </div>
    </div>
</div>
<div class="modal-footer-container">
    <div class="button-container">
        <hub-button [icon]="'trash'" [text]="'bikeshop.workshop.jobcard.quote.remove_from_quote' | translate"
            [style]="'borderless-secondary'" [size]="'xl'" (buttonClick)="removeLineItem()"></hub-button>
        <hub-button [text]="'general.apply' | translate" [style]="'secondary'" [disabled]="!valid()" [size]="'xl'"
            (buttonClick)="applyChanges()"></hub-button>
    </div>
    <div class="short-cut-container">
        <span><daz-icon [name]="'enter'" [size]="'18px'"
                [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
        translate}}
    </div>
</div>
